export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Ricardo P.',
    'Docente de Criminalística — México D.F., México',
    'Mis alumnos por fin entienden la diferencia entre indicios, evidencias y ciencias forenses, y cómo se conectan con la realidad. Antes yo misma perdía tiempo buscando cómo explicar correctamente estos conceptos complejos. Ahora entro al aula con todo listo.',
  ],
  [
    'MG',
    'Mariana G.',
    'Profesor de Ciencias Forenses — Santiago, Chile',
    'Nunca más llegué a una clase sin saber cómo explicar cadena de custodia, análisis de evidencias o criminalística digital. El material hace el trabajo pesado por mí.',
  ],
  [
    'TL',
    'Tomás L.',
    'Docente de Investigación Criminal — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos sobre criminalística están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'MR',
    'Mariana R.',
    'Docente de Criminalística | Lima, Perú',
    'El material sobre biología forense y análisis de ADN le cambió la cara a mis alumnos. Por fin entienden cómo se interpreta la genética forense y por qué. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'JC',
    'Jorge C.',
    'Profesor de Ciencias Forenses | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto y mis alumnos motivados.',
  ],
  [
    'FG',
    'Fernando G.',
    'Docente de Investigación Criminal | Caracas, Venezuela',
    'Los 100 casos prácticos transformaron cómo mis alumnos aprenden. Ahora analizan decisiones reales sobre criminalística, comprenden la cadena de custodia y evalúan alternativas de investigación. Lo aplican directamente a situaciones reales. Eso no lo encontré en ningún otro material.',
  ],
  [
    'LM',
    'Laura M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'El kit de evaluación me devolvió el tiempo de clase. Antes perdía mucho tiempo armando exámenes. Ahora tengo todo listo, coherente y vinculado con los contenidos. Mis alumnos saben exactamente qué van a ser evaluados.',
  ],
  [
    'PP',
    'Pablo P.',
    'Profesor de Criminalística | Quito, Ecuador',
    'El diccionario de conceptos fue una revelación. Mis alumnos finalmente entienden la terminología forense de forma clara. Desarrollan pensamiento crítico, cuestionan ideas previas, y comprenden criminalística desde una perspectiva integral. Eso cambió completamente su relación con el tema.',
  ],
];
